module.exports = __webpack_public_path__ + "img/mystic_clouds_print.66f2283b.png";